/** @jsxImportSource @emotion/react */

export type AmountFilterValue =
  | {
      option: 'is_equal_to' | 'is_greater_than' | 'is_less_than';
      amount: string;
    }
  | {
      option: 'is_between';
      amounts: string[];
    };

export const defaultAmountFilter: AmountFilterValue = {
  option: 'is_equal_to',
  amount: '',
};

const sanitizeAmountInput = (amount: string) => amount.replace(/[^0-9.-]+/g, '');

export type AmountFilterProps = {
  value: AmountFilterValue | null;
  conditions?: string[];
  onChange(value: AmountFilterValue): void;
};

export function AmountFilter({ onChange, ...props }: AmountFilterProps) {
  const value = props.value ?? defaultAmountFilter;
  const conditions = props.conditions;

  return (
    <>
      <div className="lp-w-full mb-16">
        <div className="selectdropdown">
          <select
            className="form-control"
            value={value.option}
            onChange={({ target: { value: option } }) =>
              onChange(
                option === 'is_between' ? { option, amounts: ['', ''] } : ({ option, amount: '' } as AmountFilterValue),
              )
            }
            data-testid="amount-filter-type-select"
          >
            {!conditions || conditions.includes('is_equal_to') ? <option value="is_equal_to">is equal to</option> : ''}
            {!conditions || conditions.includes('is_between') ? <option value="is_between">is between</option> : ''}
            {!conditions || conditions.includes('is_greater_than') ? (
              <option value="is_greater_than">is greater than</option>
            ) : (
              ''
            )}
            {!conditions || conditions.includes('is_less_than') ? (
              <option value="is_less_than">is less than</option>
            ) : (
              ''
            )}
          </select>
        </div>
      </div>
      <div className="lp-w-full lp-flex lp-align-center mb-0">
        <div className="w-24"></div>
        <div className="lp-w-full ml-16px">
          {value.option === 'is_between' ? (
            <div css={{ display: 'flex', alignItems: 'center', gap: 'var(--lp-space-xs)' }}>
              <input
                type="text"
                className="form-control radius-0"
                value={value.amounts[0]}
                onChange={({ target }) =>
                  onChange({
                    option: value.option,
                    amounts: [sanitizeAmountInput(target.value), value.amounts[1]],
                  })
                }
                data-testid="amount-filter-minamount-input"
              />
              <span> - </span>
              <input
                type="text"
                className="form-control radius-0"
                value={value.amounts[1]}
                onChange={({ target }) =>
                  onChange({
                    option: value.option,
                    amounts: [value.amounts[0], sanitizeAmountInput(target.value)],
                  })
                }
                data-testid="amount-filter-maxamount-input"
              />
            </div>
          ) : (
            <input
              type="text"
              className="form-control radius-0"
              value={value.amount}
              onChange={({ target }) =>
                onChange({
                  option: value.option,
                  amount: sanitizeAmountInput(target.value),
                })
              }
              data-testid="amount-filter-amount-input"
            />
          )}
        </div>
      </div>
    </>
  );
}
